<div class="periodic-refresh">
    <mat-select app-small-select [placeholder]="(refreshInterval ? refreshInterval.name : 'Off')|i18n"
                [(value)]="refreshInterval" (selectionChange)="onSelectRefreshInterval($event)">
        <mat-select-trigger>{{(refreshInterval ? refreshInterval.name : 'Off')|i18n}}</mat-select-trigger>
        <mat-option [value]="null">{{'Off'|i18n}}</mat-option>
        <mat-option *ngFor="let interval of refreshIntervals; trackBy: trackByIndex"
                    [value]="interval">
            {{interval.name|i18n}}
        </mat-option>
    </mat-select>
</div>
